module.exports = __webpack_public_path__ + "img/recruit_cont06_img04.02013276.png";